import React, { useEffect, useState } from 'react';
import { getRequest } from '../UrlRequest';
import DataChart from './DataChart';
import { useLocation } from 'react-router-dom';
import Loading from '../common/Loading';
import './Chart.css';

const Weight = ({ patientId, selectedDate, selectedPeriod }) => {
  const [weightData, setWeightData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const location = useLocation();
  const application = location.state?.application || 'hearton';

  useEffect(() => {
    const fetchWeightData = async () => {
      if (!patientId || !selectedDate) return;

      setLoading(true);
      setError(null);
      setWeightData(null);

      try {
        const token = localStorage.getItem('accessToken');
        
        // 기간 데이터만 가져오도록 수정
        const periodResponse = await getRequest(application,
          `/doctor/${patientId}/weight/period?on-date=${selectedDate}&period=${selectedPeriod}`,
          token
        );

        if (periodResponse && periodResponse.avg_weights?.length > 0) {
          setWeightData({
            avg_weights: periodResponse.avg_weights,
            dates: periodResponse.dates || [],
            is_dummy: periodResponse.is_dummy || []
          });
        } else {
          setError('해당 기간에 체중 데이터가 없습니다.');
        }
      } catch (error) {
        setError('체중 데이터를 불러오는 중 오류가 발생했습니다.');
      } finally {
        setLoading(false);
      }
    };

    fetchWeightData();
  }, [application, patientId, selectedDate, selectedPeriod]);

  return (
    <div className="chartcontainer">
      {loading ? (
        <Loading message="체중 데이터 로딩 중..." size="medium" />
      ) : error ? (
        <p className="error-message">{error}</p>
      ) : weightData ? (
        <>
          <div className="chart-header">
            <h3 className="chart-title">체중</h3>
            <span className="chart-value">
              현재:
              <strong>{weightData.avg_weights.slice(-1)[0]} kg</strong>
            </span>
          </div>
          <div className="chart-wrapper">
            <DataChart
              patientId={patientId}
              dataType="weight"
              endpoint={`/doctor/${patientId}/weight/period`}
              label="체중"
              selectedDate={selectedDate}
              selectedPeriod={selectedPeriod}
              chartLabels={weightData.dates}
              chartData={weightData.avg_weights}
              chartDummy={weightData.is_dummy}
            />
          </div>
        </>
      ) : (
        <p className="error-message">{selectedDate}에 대한 체중 데이터가 없습니다.</p>
      )}
    </div>
  );
};

export default Weight;
